var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSettingIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0692 12.0919L9.69 8.295C9.52245 8.24613 9.34583 8.23692 9.1741 8.26808C9.00237 8.29925 8.84025 8.36995 8.70056 8.47458C8.56087 8.57921 8.44744 8.71491 8.36924 8.87094C8.29104 9.02697 8.25022 9.19906 8.25 9.37359V19.4986C8.25 19.797 8.36853 20.0831 8.5795 20.2941C8.79048 20.5051 9.07663 20.6236 9.375 20.6236C9.48258 20.6236 9.58961 20.6082 9.69281 20.5779L15.5625 18.7765V19.4986C15.5625 19.797 15.681 20.0831 15.892 20.2941C16.103 20.5051 16.3891 20.6236 16.6875 20.6236H18.9375C19.2359 20.6236 19.522 20.5051 19.733 20.2941C19.944 20.0831 20.0625 19.797 20.0625 19.4986V17.3963L22.0692 16.781C22.3015 16.7112 22.5052 16.5687 22.6502 16.3743C22.7953 16.18 22.8741 15.9442 22.875 15.7017V13.1705C22.874 12.9281 22.7951 12.6924 22.65 12.4983C22.505 12.3041 22.3014 12.1616 22.0692 12.0919ZM15.5625 17.6002L9.375 19.4986V9.37359L15.5625 11.272V17.6002ZM18.9375 19.4986H16.6875V18.4313L18.9375 17.7408V19.4986ZM21.75 15.7017H21.7423L16.6875 17.2542V11.618L21.7423 13.1648H21.75V15.6961V15.7017Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSettingIcon2);
export default __webpack_public_path__ + "static/media/location_setting_icon2.10ef2f299b3c25303ae21de3eb767389.svg";
export { ForwardRef as ReactComponent };